import { memo, useState } from 'react';

import { Tabs } from '@mantine/core';

import { ScudExclusions, ScudMappingList, ScudReasons } from '@/entities/ScudMapping';

import { useScudMappingPermissions } from '@/shared/hooks/useScudMappingPermissions';
import { LayoutRow } from '@/shared/uikit/layouts/LayoutRow';

type TScudMappingTab = 'mapping' | 'exclusions' | 'reasons';

const panelStyle = {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	overflow: 'hidden',
} as const;

/** Сопоставление пропусков СКУД. Доступ проверяет ScudMappingRoutes */
function ScudMapping() {
	const { permissions } = useScudMappingPermissions();
	const [tab, setTab] = useState<TScudMappingTab>('mapping');

	return (
		<LayoutRow
			title={{
				title: { children: 'Сопоставление пропусков СКУД', size: 'h4', fw: 800 },
			}}
			type="once"
			style={{ height: 'calc(100vh - 116px)' }}
		>
			<Tabs
				value={tab}
				onChange={(value) => setTab((value as TScudMappingTab) ?? 'mapping')}
				keepMounted={false}
				style={{ ...panelStyle, gap: 12 }}
			>
				<Tabs.List>
					<Tabs.Tab value="mapping">Пропуска</Tabs.Tab>
					<Tabs.Tab value="exclusions">Исключения</Tabs.Tab>
					{permissions.is_admin && <Tabs.Tab value="reasons">Причины</Tabs.Tab>}
				</Tabs.List>
				<Tabs.Panel value="mapping" style={panelStyle}>
					<ScudMappingList permissions={permissions} />
				</Tabs.Panel>
				<Tabs.Panel value="exclusions" style={panelStyle}>
					<ScudExclusions permissions={permissions} />
				</Tabs.Panel>
				{permissions.is_admin && (
					<Tabs.Panel value="reasons" style={panelStyle}>
						<ScudReasons />
					</Tabs.Panel>
				)}
			</Tabs>
		</LayoutRow>
	);
}

export default memo(ScudMapping);
